<template>
  <artmisads-modal
    v-model:open="visible"
    title="Bulk Update"
    :width="1200"
    :destroyOnClose="false"
    :maskClosable="false"
    :footer="null"
    :onCancel="onCancelClose"
  >
    <div>
      <exampleTable
        v-if="showExample"
        :setDataList="setDataList"
        :dataList="dataList"
        :setShowExample="setShowExample"
      />
      <failSuccessList
        v-else
        :dataList="dataList"
        :showExample="showExample"
        :setDataList="setDataList"
        :setShowUpdateProductModal="setShowUpdateProductModal"
        :getProductList="getProductList"
        :setShowExample="setShowExample"
        :onCancel="onCancel"
      />
    </div>
  </artmisads-modal>
</template>
<script setup lang="jsx">
import { ref, defineEmits, defineExpose } from 'vue'
import exampleTable from './exampleTable.vue'
import failSuccessList from './failSuccessList.vue'
import { Modal } from 'ant-design-vue'
const visible = ref(false)
const showExample = ref(true)

const showUpdateProductModal = ref(false)
const emits = defineEmits(['refreshList'])
const open = () => {
  visible.value = true
}
const dataList = ref({
  failList: [],
  successList: [],
})
const setDataList = (data) => {
  dataList.value = data
}
const setShowUpdateProductModal = (status) => {
  showUpdateProductModal.value = status
}

const setShowExample = (status) => {
  showExample.value = status
}


const getProductList = () => {
  emits('refreshList')
}
const onCancel = () => {
 showUpdateProductModal.value = false
  dataList.value = {
    failList: [],
    successList: [],
  }
  showExample.value = true
  visible.value = false
}
const onCancelClose = () => {
  
  if(showExample.value==false){

    visible.value = true
    Modal.confirm({
      title: 'If you close this window, you will need to reselect and upload the CSV file again to update deals information. Are you sure you want to proceed? ',
      okText: 'Confirm',
      cancelText: 'Cancel',
      okType: 'danger',
      onOk: () => {
        showUpdateProductModal.value = false
        dataList.value = {
          failList: [],
          successList: [],
        }
        showExample.value = true
        visible.value = false
      },
      onCancel: () => {
        // Do nothing
      },
    })
  }else{
  showUpdateProductModal.value = false
  dataList.value = {
    failList: [],
    successList: [],
  }
  showExample.value = true
  }

}
// 暴露方法给父组件
defineExpose({
  open,
})
</script>
